import { LocationProps, ScheduleGroupProps } from 'types/CommonTypes'
import { SchoolStatProps } from './SchoolTypes'
import { UserSmsProps } from './UserTypes'
import { DateCarpoolProps, DateTimeProps, VehicleProps } from './CommunityTypes'

/**
 * Student Shared Props
 */
export enum RelationshipType {
  PARENT = 'Parent',
  GRANDPARENT = 'Grandparent',
  GUARDIAN = 'Guardian',
  OTHER = 'Other',
}

export interface UpsertStudentProps {
  userPhoneNumber: string
  userEmail?: string
  userName?: string
  userRelationship?: string
  studentId?: string
  studentName?: string
  scheduleGroupName?: string
}

/**
 * Student Input Props
 */
export interface UpsertStudentInputProps {
  students: UpsertStudentProps[]
  registrationStatus?: 'REGISTERED' | 'UNVERIFIED'
  sms?: UserSmsProps
}
export interface DeleteStudentInputProps {
  students: string[]
}

/**
 * Student Output Props
 */
type GetStudentsOutputProps = {
  // School Details
  schoolName: string
  isCarpoolActive?: boolean
  isCarpoolManagementActive?: boolean
  isDismissalManagementActive?: boolean
  isCommunityAnnouncementsActive?: boolean
  isSchoolCode?: boolean
  isSchoolSubscription?: boolean
  schoolLocation: LocationProps
  schoolScheduleGroups: ScheduleGroupProps[]
  schoolActivities: string[]
  schoolPoolRadius?: number
  schoolAdminLink?: string
  schoolDismissalSession?: string
  schoolStats?: SchoolStatProps
  // User Details
  userName: string
  userRelationship: string
  // Student Details
  studentId: string
  studentName?: string
  scheduleGroupName: string
  studentActivities: string[]
  isStudentSubscription?: boolean
  // Arrival Details
  pickupVehicle?: VehicleProps
  pickupSeatsFilled?: number
  pickupSeatsAvailable?: number
  pickupComments?: string
  // Dismissal Details
  dropoffVehicle?: VehicleProps
  dropoffSeatsFilled?: number
  dropoffSeatsAvailable?: number
  dropoffComments?: string
  // Carpool Details
  pickupLocation?: LocationProps
  arrivalCarpoolRequestDefaultTime: number | null
  arrivalCarpools: DateCarpoolProps
  dropoffLocation?: LocationProps
  dismissalCarpoolRequestDefaultTime: number | null
  dismissalCarpools: DateCarpoolProps
  // FIXME: Remove dropoffTimeDefault and dropoffTimes after we migrate UI to use dismissalCarpoolRequestDefault and dismissalCarpools
  dropoffTimeDefault?: number | null
  dropoffTimes?: DateTimeProps
  // Timestamps
  createdAt?: string
  updatedAt?: string
}
export type StudentProps = GetStudentsOutputProps

export interface UpsertStudentOutputProps {
  created: (UpsertStudentProps & { studentId: string })[]
  updated: (UpsertStudentProps & { studentId: string })[]
  errored: (UpsertStudentProps & { message: string })[]
}

export interface DeleteStudentOutputProps {
  deleted: string[]
  errored: string[]
}
